import { render, staticRenderFns } from "./first-registration.vue?vue&type=template&id=0226675e&scoped=true&"
import script from "./first-registration.vue?vue&type=script&lang=js&"
export * from "./first-registration.vue?vue&type=script&lang=js&"
import style0 from "./first-registration.vue?vue&type=style&index=0&id=0226675e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0226675e",
  null
  
)

export default component.exports